export default __webpack_public_path__ + "static/media/nda-footer-bg.8befd3d6.jpg";